import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { SECTIONS } from "../constants/sections";
import { FORM_MAP, FormCaseStudies } from "../forms";
import ModalHeader from "../shared/ModalHeader";
import ModalActions from "../shared/ModalActions";

const dialogSx = {
  "& .MuiDialog-paper": {
    borderRadius: "16px",
    background: "#1a1a1a",
    color: "text.primary",
    maxHeight: "calc(100vh - 64px)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    m: 2,
  },
};

const scrollbarSx = {
  "&::-webkit-scrollbar": { width: "8px" },
  "&::-webkit-scrollbar-track": { background: "rgba(255,255,255,0.05)" },
  "&::-webkit-scrollbar-thumb": {
    background: "rgba(255,255,255,0.2)",
    borderRadius: "4px",
  },
};

/**
 * SectionModal
 *
 * Props:
 *  editingSection  {string|null}
 *  modalDraft      {object|null}
 *  setModalDraft   {fn}
 *  onClose         {fn}
 *  onSave          {fn}
 *  onOpenCaseStudy {fn}   — for caseStudies form
 */
const SectionModal = ({
  editingSection,
  modalDraft,
  setModalDraft,
  onClose,
  onSave,
  onOpenCaseStudy,
}) => {
  if (!editingSection || !modalDraft) return null;

  const sectionMeta = SECTIONS.find((s) => s.key === editingSection);
  const FormComponent =
    editingSection === "caseStudies" ? null : FORM_MAP[editingSection];

  return (
    <Dialog
      open={!!editingSection}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      scroll="paper"
      sx={dialogSx}
    >
      <ModalHeader
        icon={sectionMeta?.icon}
        title={sectionMeta?.label}
        subtitle="Edit section content"
        onClose={onClose}
      />

      <DialogContent
        sx={{ px: 3, py: 2, pt: "12px", overflowY: "auto", flex: 1, minHeight: 0, ...scrollbarSx }}
      >
        {editingSection === "caseStudies" ? (
          <FormCaseStudies
            data={modalDraft}
            onChange={setModalDraft}
            onOpenCaseStudyModal={onOpenCaseStudy}
          />
        ) : (
          FormComponent && (
            <FormComponent data={modalDraft} onChange={setModalDraft} />
          )
        )}
      </DialogContent>

      <ModalActions
        onCancel={onClose}
        onConfirm={onSave}
        confirmLabel="Apply Changes"
      />
    </Dialog>
  );
};

export default SectionModal;